import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import AuthLayaout from 'pages/Auth/AuthLayout';
import CustomButton from 'components/Common/Button';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <AuthLayaout showBackButton>
            <Stack gap={4} p={4} justifyContent="center" alignItems="center" sx={{ width: '70%' }}>
                <Typography variant="h3" fontWeight={500} component="h1" gutterBottom>
                    404: Page Not Found
                </Typography>
                <Typography variant="h6" component="p" gutterBottom>
                    Sorry, we didn't find the page you are looking for.
                </Typography>
                <CustomButton onClick={() => navigate('/')} title="Home" sx={{ width: { xs: '90%', md: '50%' } }} />
            </Stack>
        </AuthLayaout>
    );
};

export default NotFound;
